import { FC, useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { useLogContext } from "../../hooks/useLogContext/useLogContext";

export const RouteContainer: FC = () => {
	const location = useLocation();
	const { rum, connect, providerReady } = useLogContext();

	useEffect(() => {
		if(!rum)
		{
			connect();
		}

		rum?.recordPageView(location.pathname);
	}, [ connect, location, rum, providerReady ]);

	return (<Outlet />);
}